module.exports = __webpack_public_path__ + "./Lydia_color_fe84c65d4c805bb1c5782550678d2dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Lydia_color.jpg
// module id = 616
// module chunks = 0